import { render, staticRenderFns } from "./HomeNoData.vue?vue&type=template&id=ae787b98&scoped=true"
var script = {}
import style0 from "./HomeNoData.vue?vue&type=style&index=0&id=ae787b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae787b98",
  null
  
)

export default component.exports